import request from '@/utils/http'
import { SRM } from '../constant/constant.js'

// 刷新天眼查信息
export const refreshEyeInfo = params => {
    return request({
        url: `${SRM}/supplierRiskControlInfos/refreshEyeInfo`,
        method: 'get',
        params,
    })
}

// 查询天眼查信息
export const searchEyeInfo = params => {
    return request({
        url: `${SRM}/supplierRiskControlInfos/searchEyeInfo`,
        method: 'get',
        params,
    })
}
